module.exports = require("addons-moz-compare");